import { render, staticRenderFns } from "./FieldWrapper.vue?vue&type=template&id=c28a46f2"
import script from "./FieldWrapper.vue?vue&type=script&lang=js"
export * from "./FieldWrapper.vue?vue&type=script&lang=js"
import style0 from "./FieldWrapper.vue?vue&type=style&index=0&id=c28a46f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports